<template>
  <div class="news-detail">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
<!--    <user-nav></user-nav>-->

    <div class="user-center">
      <div class="border-card-main">
        <div class="back-btn" @click="onBack"><i class="el-icon-back"></i>返回</div>
        <div class="news-title">{{detail.title}}</div>
        <div class="news-info">
          <span>阅读量：{{detail.views}}</span>
          <span>发布时间：{{detail.createtime}}</span>
        </div>
        <div class="news-detail-content" v-html="detail.content"></div>
      </div>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import userNav from "@/components/userNav/index"
import footerBox from "@/components/footerBox/index"
import {apiNewsIndex, apiIndexHelp, apiNewsad} from "@/api/api"
export default {
  components:{headerNav, userNav, footerBox},
  name: "newsDetail",
  data(){
    return{
      detail: "",
      type: "",
      pid: 0
    }
  },
  mounted(){
    if(this.$route.query.type){
      this.type = this.$route.query.type;
    }
    if(this.$route.query.pid){
      this.pid = this.$route.query.pid;
    }
    if(this.$route.query.id){
      this.loadData(this.$route.query.id);
    }else{
      this.$message.error("找不到文章");
      this.onBack();
    }
  },
  methods:{
    onBack(){
      this.$router.go(-1);
    },
    loadData(id){
      if(this.type === "help" && this.pid > 0){
        apiNewsIndex({
          page: 1,
          limit: 9999,
          id: this.pid
        }).then(res => {
          var data = res.data.article_list.data;
          for(var i = 0; i < data.length; i++){
            if(data[i].id == id){
              this.detail = data[i];
              const regex = new RegExp('<img', 'gi');
              this.detail.content = this.detail.content.replace(regex, '<img style="max-width: 100%; height: auto;"');
            }
          }
        })
      }else if(this.type === "article"){
        apiNewsad().then(res => {
          var data = res.data.data;
          for(var i = 0; i < data.length; i++){
            if(data[i].id == id){
              this.detail = data[i];
              const regex = new RegExp('<img', 'gi');
              this.detail.content = this.detail.content.replace(regex, '<img style="max-width: 100%; height: auto;"');
            }
          }
        })
      }else{
        apiNewsIndex({name: "关于我们"}).then(res => {
          if(res.code === 1){
            console.log(res.data.article_list);
            if(res.data.article_list && res.data.article_list.data.length > 0){
              this.detail = res.data.article_list.data[0];
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.news-detail {
   min-height: 100vh;
    position: relative;
    padding-bottom: 80px;
    background-color: #eeeeee;

    .user-center {
      width: 1300px;
      margin: 0 auto;
      //padding-left: 180px;

      .border-card-main {
        min-height: calc(100vh - 190px);
        background-color: #ffffff;
        padding: 20px;

        .back-btn{
          font-weight: bold;
          color: #127AF7;
          cursor: pointer;
        }
        .news-title{
          text-align: center;
          color: #000;
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 5px;
        }
        .news-info{
          text-align: center;
          margin-bottom: 20px;

          span{
            font-size: 12px;
            color: #878787;
            display: inline-block;
            margin: 0 10px;
          }
        }

      }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/news/detail.vue